// extracted by mini-css-extract-plugin
module.exports =  {"item":"_0d624b9a27--item--ihWga"};